import React from 'react';
import axios from 'axios';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import FormSelectText from 'Components/Core/Form/FormSelectText';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';
import BooleanIcon from 'Components/Core/BooleanIcon';
import './Topics.css';

export default function Topics(props) {

    const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;
	const selectForumId = props.id + '-select-forum';

	const [currentForumId, setCurrentForumId] = React.useState(0);

	async function getForumList() {
		const forumList = [{ 'id': 0, 'name': 'Alle Foren' }];
		const result = await axios.get('/Backend/webapp.php?module=Posting&task=ForenList');
		result.data.content.forEach((forum) => {
			forumList.push({ 'id': forum.id, 'name': forum.name });
		});
		return forumList;
	}

	const selectForumTag =
		<FormSelectText
			id={selectForumId}
			iconMode={false}
			wafId="form-current-forum"
			name="forumid"
			componentId={x.wau.getComponentId()}
			moduleId={props.id}
			x={x}
			classes="form-select-topic"
			default=""
			defaultKey={0}
			title="Alle Foren"
			alwaysShowSelection={false}
			afterSelect={(key) => {
				setCurrentForumId(key);
			}}
			resetIcon={false}
		/>

	const formFields =
		<React.Fragment>
			<FormElement type="text"
				x={x}  
				dialogId={dialogFormId}
				wafId={wafId}
				id="name"
				mandatory={true}
				title="Thema"
				fieldValue=""
				maxLength="20"
			/>
			<FormElement type="textarea"
				x={x}  
				dialogId={dialogFormId}
				wafId={wafId}
				id="description"
				mandatory={false}
				title="Beschreibung"
				fieldValue=""
				maxLength="200000"
			/>
			<FormElement type="checkbox" x={x}   wafId={wafId} id="disabled" title="Inaktiv" />
		</React.Fragment>


	React.useEffect(() => {
		x.waf.setAddSend(wafId, 'forumid', currentForumId);
	}, [x, wafId, currentForumId]);

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="id"
				dialogFormId={dialogFormId}
				x={x}
				classes={`module-topics`}
				tableClasses={`topic-list`}
				filterableColumns={['name', 'description', 'forumname']}
				title={props.title}
				addDeleteRow={true}
				addTitle="Neues Thema anlegen"
				module="Posting"
				listTask="TopicList"
				listParams={'&forumid=' + currentForumId}
				reloadKey={currentForumId}
				extraToolbar={selectForumTag}
				deleteTask="DeleteTopic"
				onAddHeader={(addHeader) => {
					addHeader('Thema');
					addHeader('Beschreibung');
					addHeader('Forum');
					addHeader('Deaktiviert');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'name':
						case 'description':
							return value;
						case 'disabled':
							return <BooleanIcon value={value} />;
						case 'forumname':
							return value ?? 'Alle Foren';
						default:
							return false;
					}
				}}
				onEditRow={(e, rowFields, rowId) => {
						x.waf.setAddSend(wafId, 'id', rowId);
						x.waf.set(wafId, 'name', rowFields.name);
						x.waf.set(wafId, 'description', rowFields.description);
						x.waf.set(wafId, 'disabled', rowFields.disabled);
						x.waf.hide(wafId, 'message');
						x.wad[dialogFormId].setTitle("Thema bearbeiten");
						x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'name') });
				}}
				formFields={formFields}
				formSendTask="SaveTopic"
			/>
			<DialogSelectText
				id={selectForumId}
				moduleId={props.id}
				x={x}
				classes="dialog-select-topics"
				onSetData={getForumList}
				title="Nach Forum filtern"
			/>
		</React.Fragment>
	)


};

